export default __webpack_public_path__ + "static/media/cabello-corto-hombre-azul.509033df.png";